import {getTranslation} from "../helpers/get-translation";

export default [
    getTranslation("statistics_app_month_1"),
    getTranslation("statistics_app_month_2"),
    getTranslation("statistics_app_month_3"),
    getTranslation("statistics_app_month_4"),
    getTranslation("statistics_app_month_5"),
    getTranslation("statistics_app_month_6"),
    getTranslation("statistics_app_month_7"),
    getTranslation("statistics_app_month_8"),
    getTranslation("statistics_app_month_9"),
    getTranslation("statistics_app_month_10"),
    getTranslation("statistics_app_month_11"),
    getTranslation("statistics_app_month_12")
];